<template>
  <div class="parent-box">
      <modal-main v-if="showModal" @close="showModal = false">
      <h4 slot="header">
        Search Repayment Setup
      </h4>
      <div slot="body" style="width: 100%;">
        <form>
          <select class="form-control">
            <option>Select</option>
            <option>Account</option>
            <option>Transaction Ref</option>
            <option>Al Customers</option>
            <option>Successful Onboarded</option>
          </select>
        </form>
        <div class="pt-4 text-right">
              <button type="button" @click="showModal = true" class="btn btn-warning btn-sm">Search</button>
        </div>
      </div>
    </modal-main>

     <modal-main v-if="showEdit" @close="showEdit = false">
      <h4 slot="header">
        Edit Repayment Setup
      </h4>
      <div slot="body" style="width: 100%;">
        <form  style="width: 100%;">
          <div class="form-group">
            <label for="exampleInputEmail1">Customer ID</label>
            <input
              type="email"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
           
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">New Amount</label>
            <input
              type="password"
              class="form-control"
              id="exampleInputPassword1"
            />
          </div>
        </form>
        <div class="pt-4 text-right">
          <button
            type="button"
            @click="showModal = true"
            class="btn btn-warning btn-sm"
          >
            Submit
          </button>
        </div>
      </div>
    </modal-main>
    <!-- step 1 -->
    <div class="container">
      <h2 class="page-header">Repayment Set Up History</h2>
      
    </div>
     <div class="text-right">
              <button type="button" @click="showModal = true" class="btn btn-warning btn-sm">Search</button>
              </div>


      <table class="table table-bordered">
        <br />

        <tr>
                  <th class="text-nowrap mr-5">Product</th>
          <th class="text-nowrap mr-5">Tenure</th>
          <th class="text-nowrap mr-5">Monthly Charge</th>
          <th class="text-nowrap mr-5">Total Amount</th>

          <th class="text-nowrap mr-5">First Name</th>
          <th class="text-nowrap mr-5 go-right text-left pr-5">
            Last Name
          </th>
          <th class="text-nowrap">Card</th>
          <th class="text-nowrap">Expiry M/Y</th>
          <th class="text-nowrap">Actions</th>
        </tr>
        <tr v-for="item in datar" :key="item.id">
         <td class="mr-5 text-nowrap text-center">
            {{ item.product }}
          </td>
           <td class="mr-5 text-nowrap text-center">
            {{ item.tenure }}
          </td>
           <td class="mr-5 text-nowrap text-center">
            N{{ item.monthlyCharge }}
          </td>
           <td class="mr-5 text-nowrap text-center">
            N{{ item.totalPayableAmount }}
          </td>
          <td class="ml-5 mr-5 text-nowrap text-center">
            {{ item.firstName }}
          </td>
          <td class="mr-5 text-nowrap text-center">
            {{ item.lastName }}
          </td>
          <td class="mr-5 text-nowrap text-center">{{ item.cardBIN + '****' + item.last4digits }}</td>
          <td class="mr-5 text-nowrap">{{ item.expirymonth + ' / ' + item.expiryyear }}</td>
        <td class="mr-5 text-nowrap" @click="edit"><span class="text-success">Edit Repayment</span></td>

        </tr>
      </table>
   
    <div class="footer">
      <!-- real footer item -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import ModalMain from './Modal';

export default {
  name: "FinishTab",
  props: {
    getUserSession: null,
  },
  components: {
      ModalMain
  },
  computed: {},
  data() {
    return {
      form: {
        bvn: "",
      },
      formErrors: {},
      datas: [],
      datar: [],
      showEdit: false,
      showModal: true,
      show1: true,
      show2: false,
      // activeIndex: 0,
      summary: {},
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    },
    showFirst() {
      this.show1 = true;
      this.show2 = false;
    },

    edit(){
        this.showEdit = true;
    },

    showSecond() {
      (this.show1 = false), (this.show2 = true);
    },
    getCustomers() {
      axios
        .get(
          `https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/transactionHistories`
        )
        .then((res) => {
          this.datas = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getThis() {
      axios
        .get(
          `https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/recurringPaymentSetups`
        )
        .then((res) => {
          this.datar = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  async mounted() {
    this.getCustomers();
    this.getThis();
  },
};
</script>

<style lang="scss" scoped>
.tray-show {
  background-color: #000;
  color: white;
  border: 1px solid #000;
  height: 5rem;
  padding: 10px 0px;
  width: 100%;
}

.active-link{
  color: #ffb946;
  margin-left: 1rem;
}

.right-space {
  padding-right: 10rem;
}

.cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/customer-admin/Repayment.vue